import { render, staticRenderFns } from "./role.vue?vue&type=template&id=4ac78b92&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=4ac78b92&prod&scoped=true&lang=scss"
import style1 from "./role.vue?vue&type=style&index=1&id=4ac78b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac78b92",
  null
  
)

export default component.exports